package it.neckar.lizergy.model.configuration.moduleLayout.planning

import com.meistercharts.charts.pv.roofPlanning.ModuleArea
import com.meistercharts.charts.pv.roofPlanning.ModuleAreas
import com.meistercharts.charts.pv.roofPlanning.ModuleSize
import com.meistercharts.charts.pv.roofPlanning.UnusableAreas
import kotlinx.serialization.Serializable

/**
 * Information about several module areas for a single roof
 */
@Serializable
data class ModuleAreasInformation(
  /**
   * Information for *each* module area.
   */
  val moduleAreaInformations: List<ModuleAreaInformation>,
) {

  fun modulesCount(moduleAreaPlacementsSelector: (ModuleAreaInformation) -> Boolean = { true }): Int {
    return moduleAreaInformations.filter {
      moduleAreaPlacementsSelector(it)
    }.sumOf { moduleAreaPlacementInformation ->
      moduleAreaPlacementInformation.modulesInformation.moduleInformations.filter { modulePlacementInformation ->
        modulePlacementInformation.deleted.not()
      }.size
    }
  }

  /**
   * Convert back to "live" modules
   */
  fun toModuleAreas(unusableAreas: UnusableAreas, moduleSize: ModuleSize): List<ModuleArea> {
    return buildList {
      moduleAreaInformations.map { moduleAreaInformation ->
        ModuleArea(
          id = moduleAreaInformation.id,
          initialLocation = moduleAreaInformation.location,
          initialSize = moduleAreaInformation.size,
          modulesSize = moduleSize,
          initialOrientation = moduleAreaInformation.orientation,
          gap = moduleAreaInformation.gap,
          unusableAreas = unusableAreas,
        ).also { moduleArea ->
          moduleArea.modules.clear()
          moduleArea.modules.addAll(moduleAreaInformation.modulesInformation.toModules(moduleArea))
        }
      }.let {
        addAll(it)
      }
    }
  }
}

/**
 * Converts a module grid to a REST API model
 */
fun ModuleAreas.toRestApiModel(): ModuleAreasInformation {
  return ModuleAreasInformation(
    this.moduleAreas.map { moduleArea ->
      moduleArea.toRestApiModel()
    },
  )
}
